<ng-template [ngIf]="isTeacher" [ngIfElse]="student">
  <div class="come-visit-banner" [class.tablet]="deviceService.isTablet()" [class.mobile]="deviceService.isMobile()">
    <div class="teacher" [lazyLoad]="assetsUrl('/assets/images/teacher.png')"></div>
    <div class="info">
      <h2 class="title bold">{{ 'come-visit-banner.title' | customLocale }}</h2>

      <div class="text-wrap">
        <span class="text normal">{{ 'come-visit-banner.text1' | customLocale }}</span>
        <span class="text normal">{{ 'come-visit-banner.text2' | customLocale }}</span>
        <span class="text normal">{{ 'come-visit-banner.text3' | customLocale }}</span>
      </div>

      <div class="steps">
        <div class="step-item">
          <div class="pin">1</div>
          <span class="step-text bold">{{ 'come-visit-banner.step1' | customLocale }}</span>
        </div>
        <div class="step-item">
          <div class="pin">2</div>
          <span class="step-text bold">{{ 'come-visit-banner.step2' | customLocale }}</span>
        </div>
        <div class="step-item">
          <div class="pin">3</div>
          <span class="step-text bold">{{ 'come-visit-banner.step3' | customLocale }}</span>
        </div>
      </div>
    </div>

    <div class="bottom">
      <ng-template [ngIf]="!isAuthenticated()">
        <div class="banner-btn" (click)="authorize()">
          {{ 'come-visit-banner.student.btn' | customLocale }}
        </div>
      </ng-template>

      <ng-template [ngIf]="isAuthenticated() && !isVerified()">
        <div class="banner-btn" (click)="becomeTeacher()">
          {{ 'come-visit-banner.btn' | customLocale }}
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #student>
  <div class="come-visit-banner-student" [class.student-mobile]="deviceService.isMobile()">
    <div class="student" [lazyLoad]="assetsUrl('/assets/images/student.png')"></div>
    <div class="info">
      <h3 class="title bold">{{ 'come-visit-banner.student.title' | customLocale }}</h3>
      <span class="subtitle normal">{{ 'come-visit-banner.student.subtitle' | customLocale }}</span>

      <span class="text normal">{{ 'come-visit-banner.student.text' | customLocale }}</span>

      <div class="advantage">
        <div class="advantage-item">
          <div class="pin normal">1</div>
          <span class="advantage-text bold">{{ 'come-visit-banner.student.advantage1' | customLocale }}</span>
        </div>

        <div class="advantage-item">
          <div class="pin normal">2</div>
          <span class="advantage-text bold">{{ 'come-visit-banner.student.advantage2' | customLocale }}</span>
        </div>

        <div class="advantage-item">
          <div class="pin normal">3</div>
          <span class="advantage-text bold">{{ 'come-visit-banner.student.advantage3' | customLocale }}</span>
        </div>

        <div class="advantage-item">
          <div class="pin normal">4</div>
          <span class="advantage-text bold">{{ 'come-visit-banner.student.advantage4' | customLocale }}</span>
        </div>
      </div>
    </div>

    <div class="bottom">
      <ng-template [ngIf]="!isAuthenticated()">
        <div class="banner-btn" (click)="authorize()">
          {{ 'come-visit-banner.student.btn' | customLocale }}
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>
